const FreezeComponent = () => {
  return (
    <div>
      <h1>FreezeComponent</h1>
    </div>
  );
};

export default FreezeComponent;